import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  background: #f8f9fa;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  max-width: 500px;
  line-height: 1.6;
`;

function RegionUnavailable() {
  return (
    <Container>
      <Title>Service Unavailable in Your Region</Title>
      <Message>
        Capstone Healthcare Staffing currently serves healthcare professionals
        in the United States. Our services are not available in your region at this time.
      </Message>
    </Container>
  );
}

export default RegionUnavailable;
